import { c as _c } from "react/compiler-runtime";
import * as SubframeCore from '@subframe/core';
import { FeatherArchive, FeatherCopy, FeatherEdit2, FeatherEye, FeatherMoreVertical, FeatherRotateCcw, FeatherTrash } from '@subframe/core';
import React from 'react';
import { DropdownMenu, IconButton } from '@/shared/components/ui';
interface ActionMenuProps {
  cumprimentoId: string;
  isArquivado?: boolean;
  onAction: (action: string, cumprimentoId: string) => void;
  disabled?: boolean;
}
const ActionMenu: React.FC<ActionMenuProps> = t0 => {
  const $ = _c(33);
  const {
    cumprimentoId,
    isArquivado,
    onAction,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      label: "Visualizar",
      icon: <FeatherEye />,
      action: "ver",
      visible: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherEdit2 />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !isArquivado;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      label: "Editar",
      icon: t3,
      action: "editar",
      visible: t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherCopy />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = !isArquivado;
  let t8;
  if ($[5] !== t7) {
    t8 = {
      label: "Duplicar",
      icon: t6,
      action: "duplicar",
      visible: t7
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = isArquivado ? "Desarquivar" : "Arquivar";
  let t10;
  if ($[7] !== isArquivado) {
    t10 = isArquivado ? <FeatherRotateCcw /> : <FeatherArchive />;
    $[7] = isArquivado;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = isArquivado ? "desarquivar" : "arquivar";
  let t12;
  if ($[9] !== t10 || $[10] !== t11 || $[11] !== t9) {
    t12 = {
      label: t9,
      icon: t10,
      action: t11,
      visible: true
    };
    $[9] = t10;
    $[10] = t11;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FeatherTrash />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const t14 = !isArquivado;
  let t15;
  if ($[14] !== t14) {
    t15 = {
      label: "Excluir",
      icon: t13,
      action: "excluir",
      visible: t14,
      className: "text-red-600"
    };
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t12 || $[17] !== t15 || $[18] !== t5 || $[19] !== t8) {
    const menuItems = [t2, t5, t8, t12, t15];
    t16 = menuItems.filter(_temp);
    $[16] = t12;
    $[17] = t15;
    $[18] = t5;
    $[19] = t8;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const visibleItems = t16;
  let t17;
  if ($[21] !== cumprimentoId || $[22] !== onAction) {
    t17 = action => {
      if (onAction) {
        onAction(action, cumprimentoId);
      }
    };
    $[21] = cumprimentoId;
    $[22] = onAction;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const handleItemClick = t17;
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FeatherMoreVertical />;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== disabled) {
    t19 = <SubframeCore.DropdownMenu.Trigger asChild={true}><IconButton variant="neutral-tertiary" icon={t18} disabled={disabled} size="small" /></SubframeCore.DropdownMenu.Trigger>;
    $[25] = disabled;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== handleItemClick || $[28] !== visibleItems) {
    t20 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content side="bottom" align="end" sideOffset={8} asChild={true} className="animate-fade-in"><DropdownMenu>{visibleItems.map((item_0, index) => <DropdownMenu.DropdownItem key={index} icon={item_0.icon} onClick={() => handleItemClick(item_0.action)} className={item_0.className}>{item_0.label}</DropdownMenu.DropdownItem>)}</DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[27] = handleItemClick;
    $[28] = visibleItems;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t19 || $[31] !== t20) {
    t21 = <SubframeCore.DropdownMenu.Root>{t19}{t20}</SubframeCore.DropdownMenu.Root>;
    $[30] = t19;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  return t21;
};
export default ActionMenu;
function _temp(item) {
  return item.visible;
}